import { render, staticRenderFns } from "./ModalPaymentFrequency.vue?vue&type=template&id=2ecd3f4c&scoped=true&"
import script from "./ModalPaymentFrequency.vue?vue&type=script&lang=js&"
export * from "./ModalPaymentFrequency.vue?vue&type=script&lang=js&"
import style0 from "./ModalPaymentFrequency.vue?vue&type=style&index=0&id=2ecd3f4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd3f4c",
  null
  
)

export default component.exports